import {
  Component,
  ChangeDetectionStrategy,
  inject,
  signal,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { FormComponent } from '@classes/form';
import { Article, SubjectSection } from '@models/article';
import { AssetFormatterPipe } from '@pipes/asset-formatter-pipe';

// TODO: fetch data

@Component({
  selector: 'app-category-list',
  imports: [RouterLink, AssetFormatterPipe],
  templateUrl: './category-list.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './category-list.scss',
})
export class CategoryList extends FormComponent {
  private router = inject(Router);

  protected section: SubjectSection = new SubjectSection();
  protected featured = signal<Article | null>(null);
  override data = signal<Article[]>([]);

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const slug = params.get('slug') ?? '';

      this.restart();

      if (slug) {
        this.loadEndpoint = `api/subject/${slug}`;

        this.load();
      } else {
        this.router.navigate(['/404'], { replaceUrl: true });
      }
    });
  }

  restart() {
    this.initialized.set(false);
    this.startLoading();
    this.data.set([]);
  }

  override onLoadSuccess(response: any): void {
    const { articles, section } = response.data;

    if (articles) {
      if (articles[0]) {
        this.featured.set(articles[0]);

        this.data.set(articles.slice(1));
      } else {
        this.data.set(articles);
      }
    }

    if (section) {
      this.section = section;
    }

    super.onLoadSuccess(response);
  }

  override onLoadError(error: any): void {
    this.router.navigate(['/404'], { replaceUrl: true });

    console.error(error);
  }
}
